
export const APPOINTMENT_REQUEST_TODAY = 'APPOINTMENT_REQUEST_TODAY';
export const APPOINTMENT_REQUEST_TODAY_SUCCESS = 'APPOINTMENT_REQUEST_TODAY_SUCCESS';
export const APPOINTMENT_REQUEST_TODAY_ERROR = 'APPOINTMENT_REQUEST_TODAY_ERROR';


export const APPOINTMENT_REQUEST_UPCOMING = 'APPOINTMENT_REQUEST_UPCOMING';
export const APPOINTMENT_REQUEST_UPCOMING_SUCCESS = 'APPOINTMENT_REQUEST_UPCOMING_SUCCESS';
export const APPOINTMENT_REQUEST_UPCOMING_ERROR = 'APPOINTMENT_REQUEST_UPCOMING_ERROR';

export const APPOINTMENT_REQUEST_PAST = 'APPOINTMENT_REQUEST_PAST';
export const APPOINTMENT_REQUEST_PAST_SUCCESS = 'APPOINTMENT_REQUEST_PAST_SUCCESS';
export const APPOINTMENT_REQUEST_PAST_ERROR = 'APPOINTMENT_REQUEST_PAST_ERROR';